"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _MoveDown = _interopRequireDefault(require("@rsuite/icon-font/lib/action/MoveDown"));

// Generated by script, don't edit it please.
var MoveDown = (0, _createSvgIcon["default"])({
  as: _MoveDown["default"],
  ariaLabel: 'move down',
  category: 'action',
  displayName: 'MoveDown'
});
var _default = MoveDown;
exports["default"] = _default;
module.exports = exports.default;